/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const COMPONENT_DETAILS_WITHIN_SET_CONSTANTS = {
  removeFromSetButton: 'remove-from-set-button',
  removeModal: 'remove-modal',
};
